import React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

import { WithTranslation, withTranslation, Trans } from 'react-i18next';
import { DialogContentText } from '@material-ui/core';
import theme from 'themes';
import themeDialog from 'themes-dialog';

export type Content = {
    icon?: any,
    message: string,
    messageBoldPrimary?: string,
    color?: string
}

interface ModalProps {
    open: boolean,
    okCallback: () => void,
    okText: string,
    cancelCallback?: () => void,
    dialogContent: Content[],
}



class Notifier extends React.Component<ModalProps & WithStyles<typeof styles> & WithTranslation> {

    Icon = (Icon: any, color: string = '#458B00') => {
        return <Icon style={{ fontSize: "25px", marginRight: "10px", float: "left", color: color }} /> 
    }

    render() {
        const { classes } = this.props;
        

        return (
            <Dialog
                maxWidth="xs"
                open={this.props.open}
                onClose={this.props.cancelCallback}
                fullWidth
            >
                <DialogTitle disableTypography>
                    <Typography gutterBottom variant="h5" component="h2" color="primary" style={{ fontSize: "1.25rem", textTransform: "lowercase" }}>
                        <b><Trans>Potwierdzenie</Trans></b>
                    </Typography>
                    <hr />
                </DialogTitle>
                <DialogContent>


                    {this.props.dialogContent.map((text, index) => (
                        <DialogContentText variant="h5" component="h2" key={index} color="textSecondary" className={`${classes.padding} ${classes.gutterBottom}`} style={{ paddingLeft: text.message.includes("*") ? "12px" : "0", minHeight: "25px" }}>
                            {text.icon ? this.Icon(text.icon, text.color ? text.color : "#458B00") : null}
                            <span style={{float: "left", paddingTop: index === 2 || index === 1 ? "2px": "0px"}}>{text.message}</span>
                            {text.messageBoldPrimary ?
                                <b className={classes.primary} style={{float: "right", paddingTop: index === 2 || index === 1 ? "2px": "0px", color: text.color ? text.color : themeDialog.palette.primary.main}}>{text.messageBoldPrimary}</b> : null}
                        </DialogContentText>
                    ))}



                </DialogContent>
                <DialogActions>
                    {this.props.cancelCallback ?
                    <Button variant="outlined" color="primary" size="small" className={classes.actionButtons}
                        onClick={this.props.cancelCallback}
                    >
                        <b><Trans>Back</Trans></b>
                    </Button> : null}
                    <Button variant="contained" color="primary" size="small" className={classes.actionButtons}
                        onClick={this.props.okCallback}
                    >
                        <b>{this.props.okText}</b>
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

const styles = (theme: Theme) => ({
    textAlignLeft: {
        textAlign: 'left' as 'left',
    },
    fontWeightNormal: {
        fontWeight: 'normal' as 'normal',
    },
    uppercase: {
        textTransform: "uppercase" as "uppercase"
    },
    input: {
        backgroundColor: '#ffffff',
        color: "rgb(0, 0, 0)"
    },
    primary: {
        color: theme.palette.primary.main
    },
    actionButtons: {
        textTransform: "none" as "none",
        fontSize: '0.8rem'
      },
      padding: {
        //whiteSpace: "pre" as "pre",
        paddingLeft: "7px",

        "@media (max-width: 600px)": {
            fontSize: "0.95rem",
        },
    },
    gutterBottom: {
        marginBottom: '0.5em',
        display: "flow-root" as "flow-root"
    },
});

export default withTranslation()(withStyles(styles)(Notifier));